import { Typography, Button } from 'antd';
import React from 'react';

import { TrialBenefitsList } from './TrialBenefitsList';
import { ModalTemplate } from './ModalTemplate';
import { useTrial } from '../useTrial';
import useTrackTrialEvent from '../useTrackTrialEvent';

function TrialStartedModal() {
  const { isInTrial, isLegacyTrial, freeTrialState, updateFreeTrialState } = useTrial();
  const track = useTrackTrialEvent();

  const open = React.useMemo(
    () => isInTrial && !freeTrialState.user.trialStartedModalClosed,
    [isInTrial, freeTrialState.user.trialStartedModalClosed]
  );

  const onOk = () => {
    updateFreeTrialState({
      state: {
        trialStartedModalClosed: true,
        trialWalkthrough: {
          ...freeTrialState.user.trialWalkthrough,
          displayCacheFreshness: true,
          displayRenderCounter: true,
        },
      },
      scope: 'user',
    });
  };

  const onClose = () => {
    track('BannerClosed', { banner_name: 'ExploreBenefits' });

    updateFreeTrialState({ state: { trialStartedModalClosed: true }, scope: 'user' });
  };

  React.useEffect(() => {
    if (open) {
      track('BannerShown', { banner_name: 'ExploreBenefits' });
    }
  }, [open]);

  return (
    <ModalTemplate
      open={open}
      onCancel={onClose}
      onOk={onOk}
      title={isLegacyTrial ? 'Welcome to the Essential plan!' : 'Welcome to your free Starter trial!'}
      footer={[
        <Button key="ok" type="primary" onClick={onOk}>
          {isLegacyTrial ? 'Get started' : 'Start trial'}
        </Button>,
      ]}
    >
      <div style={{ marginBottom: 24 }}>
        {isLegacyTrial ? (
          <>
            <Typography.Text>
              Ready to maximize your account? Enjoy all the benefits of the elevated Essential plan for the next 30
              days.
            </Typography.Text>
            <TrialBenefitsList variant="legacy" />
          </>
        ) : (
          <>
            <Typography.Paragraph>Your 30-day trial includes:</Typography.Paragraph>
            <TrialBenefitsList variant="starter" />
            <Typography.Paragraph style={{ marginTop: 24 }}>
              Ongoing benefits. Completely free. No credit card required.{' '}
            </Typography.Paragraph>
            <Typography.Paragraph>Let’s dive in!</Typography.Paragraph>
          </>
        )}
      </div>
    </ModalTemplate>
  );
}

export default TrialStartedModal;
